import React from 'react';
import { formatCents } from '../anniversary/format';
import { balanceByCurrency } from './timeline';

// BalanceCheckDetails shows the total against the limit; when the player is over it, the
// currencies that hold the money.
export default function BalanceCheckDetails({ balance }) {
  const byCurrency = balanceByCurrency(balance.accounts);
  return (
    <div className="space-y-2 text-xs font-medium text-ink-dim">
      <p>
        Total <span className="font-bold text-ink">{formatCents(balance.total_usd_cents)}</span> · must be below{' '}
        <span className="font-bold text-ink">{formatCents(balance.limit_usd_cents)}</span>
      </p>
      {balance.status === 'fail' && byCurrency.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5">
          <span>Balance held in:</span>
          {byCurrency.map((c) => (
            <span key={c.currency} className="rounded-md bg-surface-2 px-2 py-0.5 text-ink">
              <span className="font-bold">{c.currency}</span> {formatCents(c.usd_cents)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
